import { NavLink } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { athleteTabs } from './athleteNavigation'
import { useGetUnreadCountQuery } from '@/redux/messagesApi'

/**
 * Phone navigation: five equal tabs pinned to the bottom, under the thumb. Tabs use their short
 * label when they have one, so every label fits its fifth of a narrow phone with room around it.
 */
const BottomNav = () => {
  const { data } = useGetUnreadCountQuery()
  const unread = data?.unreadCount ?? 0
  return (
    <nav
      aria-label="Main"
      className="fixed inset-x-0 bottom-0 z-20 border-t border-border bg-card pb-[env(safe-area-inset-bottom)] md:hidden"
    >
      <ul className="mx-auto flex h-[60px] max-w-md">
        {athleteTabs.map((t) => (
          <li key={t.path} className="min-w-0 flex-1">
            <NavLink
              to={t.path}
              end={t.end}
              className={({ isActive }) =>
                cn(
                  'flex w-full flex-col items-center gap-0.5 pt-2 pb-1.5 text-xs font-semibold',
                  isActive ? 'text-[#0F172A]' : 'text-muted-foreground',
                )
              }
            >
              {({ isActive }) => (
                <>
                  <span
                    className={cn(
                      'relative flex h-7 w-12 items-center justify-center rounded-full',
                      isActive && 'bg-[#C0FD72]',
                    )}
                  >
                    <t.icon className="h-5 w-5" strokeWidth={isActive ? 2.25 : 1.75} />
                    {t.showUnreadBadge && unread > 0 ? (
                      <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-[#DC2626] px-1 text-xs font-bold text-[#FFFFFF]">
                        {unread > 99 ? '99+' : unread}
                      </span>
                    ) : null}
                  </span>
                  <span className="whitespace-nowrap">{t.shortLabel ?? t.label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default BottomNav
